import AttendeeNotification from './containers/AttendeeTicketNotification';

export default AttendeeNotification;
